document.addEventListener('DOMContentLoaded', function () {
  const divItemSelector = '.accordion-item';
  const divHeaderSelector = '.accordion-header';
  const divContentSelector = '.accordion-content';

  function isInteractiveElement(target) {
    return target.closest(
      'a, button, input, select, textarea, iframe, video, audio, label, summary, [contenteditable="true"]'
    );
  }

  function getRelativeScrollPosition(element) {
    const top = element.getBoundingClientRect().top + window.scrollY;
    return Math.max(0, window.scrollY - top);
  }

  function closeDivAccordion(item) {
    const content = item.querySelector(`:scope > ${divContentSelector}`);
    const header = item.querySelector(`:scope > ${divHeaderSelector}`);
    if (!content) return;

    // 保存用
    item.dataset.ougiSavedY = getRelativeScrollPosition(content);

    // 閉じる
    content.style.maxHeight = '0px';
    item.classList.remove('active');

    if (header) {
      header.setAttribute('aria-expanded', 'false');
      // 見出しへスクロール（smooth に）
      header.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function openDivAccordion(item) {
    const content = item.querySelector(`:scope > ${divContentSelector}`);
    const header = item.querySelector(`:scope > ${divHeaderSelector}`);
    if (!content) return;

    item.classList.add('active');
    content.style.maxHeight = content.scrollHeight + 'px';

    if (header) {
      header.setAttribute('aria-expanded', 'true');
    }

    const savedY = Number(item.dataset.ougiSavedY || 0);
    if (savedY > 0) {
      setTimeout(function () {
        const top = content.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: top + savedY,
          behavior: 'smooth'
        });
      }, 120);
    }
  }

  function setupDivAccordions() {
    document.querySelectorAll(divItemSelector).forEach(function (item) {
      const header = item.querySelector(`:scope > ${divHeaderSelector}`);
      const content = item.querySelector(`:scope > ${divContentSelector}`);
      if (!header || !content) return;

      content.style.maxHeight = item.classList.contains('active')
        ? content.scrollHeight + 'px'
        : '0px';

      header.setAttribute('role', 'button');
      header.setAttribute('tabindex', '0');
      header.setAttribute(
        'aria-expanded',
        item.classList.contains('active') ? 'true' : 'false'
      );

      header.addEventListener('click', function () {
        if (item.classList.contains('active')) {
          closeDivAccordion(item);
        } else {
          const parentAccordion = item.parentElement;
          if (parentAccordion) {
            parentAccordion
              .querySelectorAll(`:scope > ${divItemSelector}.active`)
              .forEach(function (sibling) {
                if (sibling !== item) closeDivAccordion(sibling);
              });
          }
          openDivAccordion(item);
        }
      });

      content.addEventListener('dblclick', function (event) {
        if (isInteractiveElement(event.target)) return;
        closeDivAccordion(item);
      });
    });
  }

  function closeDetails(details) {
    const summary = details.querySelector(':scope > summary');
    if (summary) {
      details.dataset.ougiSavedY = getRelativeScrollPosition(details);
      // details を閉じる
      details.removeAttribute('open');
      // 見出しへスクロール（scroll-margin-top の分だけ余白を持たせる）
      summary.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      // summary がない場合は位置情報のみ保存
      details.dataset.ougiSavedY = getRelativeScrollPosition(details);
      details.removeAttribute('open');
    }
  }

  function setupDetailsAccordions() {
    document.querySelectorAll('details').forEach(function (details) {
      const summary = details.querySelector(':scope > summary');
      if (!summary) return;

      details.addEventListener('toggle', function () {
        // 開いたときの処理（前の位置に戻る）
        if (!details.open) return;
        const savedY = Number(details.dataset.ougiSavedY || 0);
        if (savedY > 0) {
          setTimeout(function () {
            const top = details.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
              top: top + savedY,
              behavior: 'smooth'
            });
          }, 120);
        }
      });

      details.addEventListener('dblclick', function (event) {
        if (!details.open) return;
        if (event.target.closest('summary')) return;
        if (isInteractiveElement(event.target)) return;

        event.preventDefault();
        closeDetails(details);
      });

      let lastTapTime = 0;
      let startX = 0;
      let startY = 0;

      details.addEventListener(
        'touchstart',
        function (event) {
          if (!event.touches || !event.touches.length) return;
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        },
        { passive: true }
      );

      details.addEventListener(
        'touchend',
        function (event) {
          if (!details.open) return;
          if (event.target.closest('summary')) return;
          if (isInteractiveElement(event.target)) return;

          const touch = event.changedTouches && event.changedTouches[0];
          if (!touch) return;

          const moveX = Math.abs(touch.clientX - startX);
          const moveY = Math.abs(touch.clientY - startY);

          if (moveX > 12 || moveY > 12) return;

          const now = Date.now();

          if (now - lastTapTime < 450) {
            event.preventDefault();
            closeDetails(details);
            lastTapTime = 0;
          } else {
            lastTapTime = now;
          }
        },
        { passive: false }
      );
    });
  }

  setupDivAccordions();
  setupDetailsAccordions();
});